import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';

import DataTable from './datatable';

import ContainerHeader from '../../../components/ContainerHeader/index';
import * as userdetails from '../../../actions/userdetails';

class RejectedRoles extends Component {

    componentDidMount() {
        // console.log('props', this.props)
        this.props.actions.resetUser();
        this.props.actions.getRejectedRolesList();
    }

    render() {
        const { userDetails, match, loginUser } = this.props;

        let dataList = <tr><td></td></tr>;
        let message = null;
        // console.log('userDetails', userDetails);
        if ((userDetails && userDetails.Status)||(userDetails && userDetails.actionStatus)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0) {
            // dataList = userDetails.UserdetailsList.map((_data, index) => {
            //     return (<TableCell key={index} data={_data} index={index} loggedinUserRole_id={loginUser.data.role_id} />);
            // })
        }

        return (
            <div className="slideInUpTiny ">
            {message}
                <ContainerHeader title="Rejected Role List" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                {/* <h1 className="bg-primary text-white p-3 mb-0">Rejected Role List</h1> */}
                                <DataTable
                                    data={userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0 ? userDetails.UserdetailsList : null} 
                                    loggedinUserRole_id={loginUser.data.role_id}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { userDetails, loginUser } = state
    const { match } = ownProps
    return { userDetails, match, loginUser }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userdetails, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(RejectedRoles);


// WEBPACK FOOTER //
// ./app/userdetails/RejectedRoles/index.js